import { useEffect } from 'react'

import { useGetDriverProfile } from '../../hooks/api/drivers/useGetDriverProfile'
import { DriverData } from '../../types/interfaces'
import { useAuthContext } from '../auth/hooks/useAuthContext'

const useRouter = () => {
  const { setUserStatus } = useAuthContext()

  const { data, isError, isLoading } = useGetDriverProfile<DriverData>()

  useEffect(() => {
    if (data && !isLoading) {
      setUserStatus({
        status: data.status,
        tz: data.city?.timezone,
      })
    }
  }, [data, isLoading])

  return { data, isError, isLoading }
}

export default useRouter
